// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__23Gyh","errorLogs":"EditorFooter_errorLogs__2oiAx"};